module.exports = __webpack_public_path__ + "static/media/111.11.SDI_9230_LOEWE_1F.5188454d.png";